export default "__VITE_ASSET__DvBxQyj1__"